<svg
    data-testid="svg-icon"
    attr.class="icon icon-{{ icon | lowercase }}">
    <use attr.xlink:href="#icon-{{ set }}-{{ icon | lowercase }}"></use>
</svg>
